import { getWebApp, isInTelegram } from '../telegram'

/**
 * Клавиатура телефона и листы снизу. На iOS (в Safari и в Telegram) клавиатура
 * не сжимает страницу, а закрывает её низ: лист с полем и кнопкой «Создать»
 * уезжает под неё. Здесь считаем, сколько снизу закрыто, и пишем в `--kb`:
 * `Dialog` поднимает лист на эту высоту. На Android страница сжимается сама,
 * `--kb` остаётся 0.
 *
 * Высоту видимой области в Telegram (viewportStableHeight) SDK пишет в
 * `--tg-viewport-stable-height` по событию viewportChanged; на неё опирается
 * `--app-height` в index.css. Здесь то же событие пересчитывает `--kb`.
 */

// Меньше — это панели браузера, а не клавиатура.
const KEYBOARD_MIN_PX = 120

export function keyboardInset(innerHeight: number, vvHeight: number, vvOffsetTop: number): number {
  const covered = Math.round(innerHeight - vvHeight - vvOffsetTop)
  return covered >= KEYBOARD_MIN_PX ? covered : 0
}

export function initViewport(): void {
  const vv = window.visualViewport
  if (!vv) return
  const root = document.documentElement
  let frame = 0
  const update = () => {
    cancelAnimationFrame(frame)
    frame = requestAnimationFrame(() => {
      const properties = {
        '--kb': `${keyboardInset(window.innerHeight, vv.height, vv.offsetTop)}px`,
        '--visual-height': `${Math.round(vv.height)}px`,
        '--visual-top': `${Math.round(vv.offsetTop)}px`,
      }
      for (const [name, value] of Object.entries(properties)) {
        if (root.style.getPropertyValue(name) !== value) root.style.setProperty(name, value)
      }
    })
  }
  vv.addEventListener('resize', update)
  vv.addEventListener('scroll', update)
  const tg = getWebApp()
  if (tg && isInTelegram()) tg.onEvent('viewportChanged', update)
  update()
}

/** Поле с автофокусом сразу поднимает клавиатуру. В Telegram на телефоне не надо: человек сам тронет поле. */
export function canAutoFocus(): boolean {
  if (!isInTelegram()) return true
  return !window.matchMedia('(pointer: coarse)').matches
}
